import { CFG } from '../config';
import { deltaPercent, sumMacros } from '../utils';
import type { DayData, StravaActivity } from '../types';

interface Props {
  days: DayData[];
  prevDays: DayData[];
  activities: StravaActivity[];
}

function DeltaBadge({ cur, prev }: { cur: number; prev: number }) {
  const d = deltaPercent(cur, prev);
  if (!d) return null;
  const arrow = d.direction === 'up' ? '\u25B2' : '\u25BC';
  const cls = d.direction === 'up' ? 'delta-up' : 'delta-down';
  return <span class={cls}>{arrow} {d.pct}%</span>;
}

export function HeroCards({ days, prevDays, activities }: Props) {
  const cur = sumMacros(days);
  const prev = sumMacros(prevDays);

  const avgCal = cur.daysWithData > 0 ? cur.calories / cur.daysWithData : 0;
  const deficit = Math.round(CFG.tdee - avgCal);

  let defColor = 'var(--magenta)';
  if (deficit >= 300 && deficit <= 700) defColor = 'var(--green)';
  else if ((deficit >= 100 && deficit < 300) || (deficit > 700 && deficit <= 1000)) defColor = 'var(--yellow)';

  return (
    <div class="hero">
      <div class="hero-card hc-1">
        <div class="hc-label">TOTAL KCAL</div>
        <div class="hc-val">{cur.calories ? cur.calories.toLocaleString('ru') : '--'}</div>
        <div class="hc-delta">
          {cur.calories && prev.calories ? <DeltaBadge cur={cur.calories} prev={prev.calories} /> : null}
        </div>
      </div>
      <div class="hero-card hc-2">
        <div class="hc-label">PROTEIN</div>
        <div class="hc-val">{cur.protein ? `${Math.round(cur.protein)}g` : '--'}</div>
        <div class="hc-delta">
          {cur.protein && prev.protein ? <DeltaBadge cur={cur.protein} prev={prev.protein} /> : null}
        </div>
      </div>
      <div class="hero-card hc-3">
        <div class="hc-label">WORKOUTS</div>
        <div class="hc-val">{activities.length || '--'}</div>
      </div>
      <div class="hero-card hc-4">
        <div class="hc-label">DEFICIT</div>
        <div class="hc-val" style={{ color: cur.daysWithData > 0 ? defColor : undefined, textShadow: 'none' }}>
          {cur.daysWithData > 0 ? deficit : '--'}
        </div>
      </div>
    </div>
  );
}
